import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

interface Props {
  isChecked: boolean;
  setIsChecked: Dispatch<SetStateAction<boolean>>;
}

const AgreeText = styled.div`
  font-size: 1.25em;
  align-self: center;
`;

const Terms = styled.a`
  color: var(--primary-color3);
`;

function Agreement(props: Props): JSX.Element {
  /* Define state / hook */
  const { isChecked, setIsChecked } = props;
  const { t } = useTranslation();

  /* Custom Data Object for render or other usages */

  /* Render control function / logic */

  /* Data Change Listeners - useEffect/useMemo/useCallback */

  /* Styling */

  /* Render */
  return (
    <AgreeText className="flex mt-3 mb-3">
      <input
        aria-label="checkbox"
        checked={isChecked}
        className="my-0"
        data-test="terms-checkbox"
        type="checkbox"
        onChange={() => setIsChecked(!isChecked)}
      />
      <div className="align-self-center">
        {t('modal.agreeTermsAndConditions')}
        <Terms
          className="ml-1"
          href={`${process.env.REACT_APP_API_BASE_URL}/doc/terms-and-conditions`}
          target="_blank"
        >
          {t('modal.termsAndConditions')}
        </Terms>
      </div>
    </AgreeText>
  );
}

export default Agreement;
